import type { SVGProps } from 'react';
const SvgUpland = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M31.18 7.628a5.48 5.48 0 0 0-4.14.74 5.4 5.4 0 0 0-1.8 2 2.76 2.76 0 0 0-2.46 1.04l-3.64 4.6a13.44 13.44 0 0 0-10.5 7.24l-4.14 7.62 7-1.34h4.7a11.2 11.2 0 0 0 2.3-.26l.86-.22c5.54-1.68 9.74-7.58 8-13.52l3.14-1.66-2.7-1a2.44 2.44 0 0 0-.76-1.7 3.2 3.2 0 0 1 1.08-1.12 3.46 3.46 0 0 1 2.62-.46 3.5 3.5 0 0 1 2.16 1.48l1.6-1.1a5.44 5.44 0 0 0-3.32-2.34" />
  </svg>
);
export default SvgUpland;
